import { Badge, Text, Tooltip, tokens } from '@fluentui/react-components';
import type { ClientLanguage } from '../../api/reviews';
import { useTranslation } from '../../i18n';

/**
 * The client's language (en/es/pt), as the SERVER read it live from the CRM record via core (fleet ruling
 * 2026-10-27). Never the creation-day copy a review document may still carry. Unknown shows as a dash with the
 * reason, never as English.
 */
export function ClientLanguageBadge({ language }: { language: ClientLanguage | null | undefined }) {
  const { t } = useTranslation();
  if (!language) {
    return (
      <Tooltip content={t('clientLanguage.unknown')} relationship="description">
        <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>-</Text>
      </Tooltip>
    );
  }
  return (
    <Tooltip content={t(`emailTemplates.languages.${language}`)} relationship="label">
      <Badge appearance="outline" size="small">{language.toUpperCase()}</Badge>
    </Tooltip>
  );
}
